import React  from "react";
import MUIDataTable from "mui-datatables";
import {
  createMuiTheme,
  MuiThemeProvider,
} from "@material-ui/core/styles";

import axios from 'axios';
import Fab from '@material-ui/core/Fab';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import ViewIcon from '@material-ui/icons/Visibility';
import DriveEtaIcon from '@material-ui/icons/DriveEta';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';

import CustomToolbar from "../../common/AddButton";
import CircularProgress from '@material-ui/core/CircularProgress';

import Button from '@material-ui/core/Button';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
 
import api from '../../common/api'

 
class Policies extends React.Component {

 constructor() {
    super();

    this.state = {
      data: '',
      contract_id: '',
      param:'',
      contract_name: '',
      isLoaded: false,
      errors:false
    }
  }

  componentDidMount() {
    const param = this.getParams().query
    this.setState({contract_id: param})

    if (param !== '0'){
      this.getContract(param).then(result => this.setState({
           contract_name: result
      }))
    } else {
      this.setState({contract_name: 'AutoCorp'});        
    }
    
    this.getPolicies(param).then(result => this.setState({
         data: Object.values(result)
    }))
  }

 getParams(location) {
    const searchParams = new URLSearchParams(window.location.search);
    return {
      query: searchParams.get("idContract")
    };
  }

 getPolicies = (contract_id) => {
  const token =localStorage.getItem('userToken')
 
  return axios
        .get(api.contract().policies(contract_id),{ headers: {"Authorization" : `Bearer ${token}`} })
        .then(res => {
          this.setState({isLoaded: true})
          return res.data
        })
        .catch(err =>{console.log(err)
        })
  }

  getContract = (contract_id) => {
   const token =localStorage.getItem('userToken')
   return axios
            .get(api.contract().get(contract_id),{ headers: {"Authorization" : `Bearer ${token}`} })
            .then(res => {
              return res.data[0].name
            })
            .catch(err =>{console.log(err)
            })

  }

  handleDelete() {
    const token = localStorage.getItem('userToken')
    return axios
     .delete(api.policy().delete(this.state.rowId),
     {params: {'policy[id]':this.state.rowId },headers: {"Authorization" : `Bearer ${token}`}}
      )
      .then(res => {
          this.setState({message: 'Politica de flota dada de baja con éxito!'})
          this.setState({errors: false})
          this.setState({rowId: ''})
      })
      .catch(err =>{
          this.setState({errors: true})
          this.setState({message: err.response.data.errors["policy.id"]})
      })

  }

  getMuiTheme = () =>
    createMuiTheme({
      overrides: {
        MuiTableCell: {
         root: {
           padding: '0px 8px 0px 8px',
           fontSize:'0.8rem'
          }
        },
        MuiTable:{
          root:{
            marginLeft: '15px'
          }
        }
      }
    });      


  render= (props) => {

      const handleRedirect = id => () =>{
        window.location.href=`/policies?idContract=${this.state.contract_id}`
      }


      const handleDialogClose = rowId => () =>{
        this.setState({errors: false})

        var state = this.state.dialogOpen
        this.setState({dialogOpen: !state})
        var policyname = ''
        this.state.data.map((val, idx)=>{
            if(val.id == rowId){
              policyname = val.name
              this.setState({rowId: val.id})
            }
        })
        if (policyname !=''){
            var message = 'Está a punto de dar de baja la politica '+policyname+'. ¿Está seguro?'
        } else {
            this.setState({errors: true})
            var message = 'Hubo un problema al dar de baja la politica de flota.'
        }
        this.setState({message: message })
      }

     const columns = [
     {
      name: "id",
      label: "Id",
      options: {
       filter: true,
       display: false,
       sort: true,
      }
     },
     {
      name: "name",
      label: "Nombre",
      options: {
       filter: false,
       sort: true,
      }
     },
     {
      name: "description",
      label: "Descripción",
      options: {
       filter: false,
       sort: true,
      customBodyRender: (value, tableMeta, updateValue) => {
        if (value === null || value ==='null'){
          return '';
        } else {
          return value;
        }
      }
      }
     },
     {
      name: "due_date",
      label: "Fecha de vencimiento",
      options: {
       filter: false,
       sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          var today = new Date();
          var dd = String(today.getDate()).padStart(2, '0');
          var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
          var yyyy = today.getFullYear();

          today = yyyy + '-' + mm + '-' + dd;
          if (value <= today){
            return (<div class="text-danger font-weight-bold">
                      <i class="material-icons">warning</i>
                        {value}
                      <i class="material-icons">warning</i>
                    </div>)
          } else {
            return value
          }
      }
      }
     },
     {
      name: "revision_code",
      label: "Cod. revisión",
      options: {
       filter: false,
       sort: true,
      }
     }
     ,
     {
      name: "tareas",
      label: "Tareas",
      options: {
          filter: false,
          sort: false,
          empty: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            const rowId = tableMeta.rowData[0]
            return (
                <div className="row">
                  <Fab color="primary" aria-label="view" style={{backgroundColor:'green'}} className='MuiButtonBase-root MuiFab-sizeSmall m-1' href={"policies/view?vPolicy="+rowId}>
                    <ViewIcon fontSize="small" /> 
                  </Fab>
                  <Fab color="secondary" aria-label="edit" className='MuiButtonBase-root MuiFab-sizeSmall m-1' href={"policies/edit?idPolicy="+rowId}>
                    <EditIcon  />
                  </Fab>
                  <Fab color="primary" aria-label="view" className='MuiButtonBase-root MuiFab-sizeSmall m-1' href={"policyVehicles?idPolicy="+rowId}>
                    <DriveEtaIcon />
                  </Fab>
                  <Fab color="primary" aria-label="view" className='MuiButtonBase-root MuiFab-sizeSmall m-1' href={"policyAudit?id="+rowId}>
                    <VerifiedUserIcon />
                  </Fab>
                  <Fab aria-label="view" className='MuiButtonBase-root MuiFab-sizeSmall m-1' style={{'box-shadow': 'none', backgroundColor: "grey" }} onClick={handleDialogClose(rowId)}>
                    <DeleteIcon fontSize="small" /> 
                  </Fab>
                </div>   
            );
          }
        }       
      }
    ];

  const options = {
    filter: true,
    selectableRows: false,
    filterType: 'dropdown',
    responsive: 'stacked',
    rowsPerPage: 10,
    customToolbar: () => {
      return (
        <CustomToolbar url={`new?idContract=${this.state.contract_id}`} />
      );
    },
    textLabels: {
          body: {
              noMatch: this.state.isLoaded ?
                  'No hay resultados' :
                  <CircularProgress />,
                  toolTip: "Ordenar",
                  columnHeaderTooltip: column => `Ordenar para ${column.label}`

          },
      filter: {
        all: "Todos los resultados",
        title: "Tus filtros"  ,
        reset: "Resetear",          
      },
      toolbar: {
        search: "Buscar",
        downloadCsv: "Exportar CSV",
        print: "Imprimir",
        viewColumns: "Ver columnas",            
        filterTable: "Filtros",
      },
      pagination: {
        next: "Siguiente",
        previous: "Anteior",
        rowsPerPage: "Cantidad por página:",
        displayRows: "de",      
      },
      selectedRows: {
        text: "fila(s) seleccionadas",
      },
    }

  };


   return(
   <div>
     <Dialog
        open={this.state.dialogOpen}
        onClose={handleDialogClose()}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
      <DialogTitle id="alert-dialog-title">Dar de baja!</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
            {this.state.message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {(!this.state.errors)?(
          (this.state.rowId ==='')?
            <div>
              <Button onClick={handleRedirect()} color="primary" >
                Continuar
              </Button>
            </div>
          :
          <div>
          <Button onClick={handleDialogClose()} color="primary" autoFocus>
            Cancelar
          </Button>
          <Button onClick={this.handleDelete.bind(this)} color="primary" >
            Continuar
          </Button>
          </div>
          
          
         )
        :(
        <div>
        <Button onClick={handleDialogClose()} color="primary" >
          Continuar
        </Button>
        </div>
        )}
      </DialogActions>
    </Dialog> 
   <MuiThemeProvider theme={this.getMuiTheme()}>

    <MUIDataTable
      title={`Políticas de flota de ${this.state.contract_name}`}
      data={Object.values(this.state.data)}
      columns={columns}
      options={options}
     />
    </MuiThemeProvider>
    </div>
    );
  }

}

export default Policies;   